import { render, staticRenderFns } from "./SvgLi.vue?vue&type=template&id=d67d138c"
import script from "./SvgLi.vue?vue&type=script&lang=js"
export * from "./SvgLi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports